<template>
    <v-card class="pa-3 grey lighten-3">
        <v-data-table :headers="tableHeader" :items="items" :search="search"
                      sort-by="from" :sort-desc="true" class="elevation-1" hide-default-footer
                      @page-count="pageCount = $event" :page.sync="page" :items-per-page="itemsPerPage">
        </v-data-table>
        <v-pagination v-if="pageCount>1" v-model="page" :length="pageCount"></v-pagination>
    </v-card>
</template>

<script>
    export default {
        name: "spieler-history",
        props: ['spieler'],
        computed: {
            landesverbaende(){ return this.$store.state.local.landesverbaende },
            lvDetails(){ return this.$store.state.realtime.landesverbaende }
        },
        data: () => ({
            log: [],
            tableHeader: [
                {text: 'von', value: 'from', sortable: true},
                {text: 'bis', value: 'until', sortable: true},
                {text: 'Landesverband', value: 'lv', sortable: true},
                {text: 'Verein', value: 'verein', sortable: true},
                {text: 'Pass Nr.', value: 'passNr', sortable: true},
                {text: 'Leihe', value: 'leihe', sortable: true},
            ],
            items: [],
            search: '',
        // pagination
            page: 1,
            pageCount: 0,
            itemsPerPage: 15,
        }),
        created(){
            this.loadVereine();
        },
        methods: {
            loadVereine(){
                let waitForLoad = false;
                this.spieler.memberships.forEach( (membership) => {
                    const lvId = membership.lvVereinId.substr(0,2);
                    if ( !this.lvDetails[lvId] ) {
                        this.$store.dispatch('bindRealtimeDocument', {
                            collection: 'landesverbaende',
                            docId: lvId,
                            storeField: 'landesverbaende.' + lvId,
                        });
                        waitForLoad = true;
                    }
                });
                if ( !waitForLoad ) { this.setItems(); }
            },
            setItems(){
                this.items = [];
                this.spieler.memberships.forEach( (membership) => {
                    let item = JSON.parse(JSON.stringify(membership));
                    item.from = item.leihe ? this.setItemFromLeihe(item.from) : item.from;
                    item.leihe = item.leihe ? 'ja' : '-';
                    const lvId = item.lvVereinId.substr(0,2);
                    const vereinId = item.lvVereinId.substr(2);
                    const lvName = this.landesverbaende.find( lv => lv.id === lvId ).name;
                    item.lv = lvId + ' / ' + lvName.replace('LV ', '');
                    item.verein = this.lvDetails[lvId].vereine[vereinId] ? vereinId + ' / ' +
                        this.lvDetails[lvId].vereine[vereinId].name : item.lvVereinId ;
                    item.passNr = item.passNr === 'ummeldung' ? 'Ummeldung' : item.passNr;
                    this.items.push(item);
                });
            },
            setItemFromLeihe(itemFrom){
                let yearNew = parseInt(itemFrom.substr(0,4))+1;
                return yearNew + '-01-01';
            }
        },
        watch: {
            spieler: {
                handler(){
                    this.loadVereine();
                },
                deep: true
            },
            lvDetails: {
                handler(){
                    this.setItems();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>